export default (
  x,
  y,
  width,
  height /*, color*/
) => `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" x="${x}" y="${y}" width="${width}" height="${height}" viewBox="0 0 24 24" fill="none">
<path d="M21 17H3" stroke="#3D4B52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 10L3 7L6 4" stroke="#3D4B52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3 7H21" stroke="#3D4B52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 20L21 17L18 14" stroke="#3D4B52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
